module.exports = __webpack_public_path__ + "media/pdf/321sprzedane_banner_2-34df5bab.png";